// Who is The Spy? Client
import { sounds } from '../sound.js';

export class SpyGameClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.secretWord = '';
    this.isSpy = false;

    this.render();
    this.setupSocketEvents();
  }

  render() {
    this.container.innerHTML = `
      <div class="spy-wrapper">
        <div class="spy-header">
          <h2>🕵️ WHO IS THE SPY?</h2>
          <div id="spy-phase-badge" class="spy-badge">PHASE: SPEAKING</div>
        </div>

        <!-- Secret Word Card Flip -->
        <div class="secret-word-container">
          <div class="secret-card" id="spy-card">
            <div class="card-front">
              <span class="card-icon">🔒</span>
              <span class="card-prompt">CLICK TO REVEAL YOUR SECRET WORD</span>
            </div>
            <div class="card-back">
              <span class="card-tag" id="spy-role-tag">CIVILIAN</span>
              <h2 id="spy-word-display">...</h2>
              <p>Describe your word carefully without revealing it to the Spy!</p>
            </div>
          </div>
        </div>

        <!-- Speaker Round & Prompt -->
        <div class="spy-prompt-box">
          <div id="spy-speaker-text" class="speaker-text">Waiting for game to begin...</div>
          
          <div id="spy-input-row" class="spy-input-row disabled">
            <input type="text" id="spy-desc-input" placeholder="Type your 1-sentence description..." maxlength="80" />
            <button id="spy-btn-speak" class="btn-action">SUBMIT</button>
          </div>
        </div>

        <!-- Live Descriptions Log -->
        <div class="spy-descriptions-log" id="spy-desc-log">
          <div class="log-title">ROUND DESCRIPTIONS</div>
        </div>

        <!-- Voting Grid Modal -->
        <div id="spy-voting-modal" class="spy-voting-modal modal-hidden">
          <h3>🗳️ VOTE TO ELIMINATE THE SPY</h3>
          <div class="voting-timer" id="spy-vote-timer">⏳ 20s</div>
          <div class="voting-grid" id="spy-voting-grid"></div>
        </div>
      </div>
    `;

    // Card Flip
    const card = document.getElementById('spy-card');
    card?.addEventListener('click', () => {
      card.classList.toggle('flipped');
      sounds.playCard();
    });

    const speakInput = document.getElementById('spy-desc-input');
    const sendDesc = () => {
      const text = speakInput.value.trim();
      if (!text) return;
      this.socket.emit('spy_speak', { text });
      speakInput.value = '';
    };

    document.getElementById('spy-btn-speak')?.addEventListener('click', sendDesc);
    speakInput?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') sendDesc();
    });
  }

  setupSocketEvents() {
    this.socket.on('spy_secretWord', (data) => {
      this.secretWord = data.word;
      this.isSpy = data.isSpy;

      const wordDisplay = document.getElementById('spy-word-display');
      const roleTag = document.getElementById('spy-role-tag');
      if (wordDisplay) wordDisplay.innerText = data.word;
      if (roleTag) {
        roleTag.innerText = data.isSpy ? '🕵️ SPY' : '🛡️ CIVILIAN';
        roleTag.style.color = data.isSpy ? '#ef4444' : '#22c55e';
      }
    });

    this.socket.on('spy_turnPrompt', (data) => {
      const isMe = data.speakerId === this.socket.id;
      const speakerText = document.getElementById('spy-speaker-text');
      const inputRow = document.getElementById('spy-input-row');
      const modal = document.getElementById('spy-voting-modal');
      if (modal) modal.classList.add('modal-hidden');

      if (speakerText) {
        speakerText.innerText = isMe ? "👉 It's your turn to speak!" : `🎙️ ${data.speakerName} is speaking...`;
        speakerText.style.color = isMe ? '#22c55e' : '#38bdf8';
      }
      if (inputRow) {
        if (isMe) inputRow.classList.remove('disabled');
        else inputRow.classList.add('disabled');
      }
    });

    this.socket.on('spy_newDescription', (data) => {
      sounds.playChime();
      const log = document.getElementById('spy-desc-log');
      if (log) {
        const item = document.createElement('div');
        item.className = 'desc-bubble';
        item.innerHTML = `<strong>${data.name}:</strong> "${data.text}"`;
        log.appendChild(item);
        log.scrollTop = log.scrollHeight;
      }
    });

    this.socket.on('spy_votingStarted', (data) => {
      sounds.playTick();
      const modal = document.getElementById('spy-voting-modal');
      const grid = document.getElementById('spy-voting-grid');
      const phaseBadge = document.getElementById('spy-phase-badge');
      if (phaseBadge) phaseBadge.innerText = 'PHASE: VOTING';

      if (modal && grid) {
        grid.innerHTML = '';
        data.alivePlayers.forEach((p) => {
          if (p.id === this.socket.id) return;
          const card = document.createElement('div');
          card.className = 'vote-card';
          card.innerHTML = `
            <span class="v-avatar">${p.avatar}</span>
            <span class="v-name">${p.name}</span>
            <button class="btn-vote">VOTE</button>
          `;
          card.querySelector('.btn-vote').addEventListener('click', () => {
            grid.querySelectorAll('.vote-card').forEach(c => c.classList.remove('selected'));
            card.classList.add('selected');
            this.socket.emit('spy_vote', { targetId: p.id });
            sounds.playPop();
          });
          grid.appendChild(card);
        });
        modal.classList.remove('modal-hidden');
      }
    });

    this.socket.on('spy_tick', (data) => {
      const timer = document.getElementById('spy-vote-timer');
      if (timer) timer.innerText = `⏳ ${data.timer}s`;
    });

    this.socket.on('spy_playerEliminated', (data) => {
      sounds.playExplosion();
      const modal = document.getElementById('spy-voting-modal');
      if (modal) modal.classList.add('modal-hidden');
      alert(`💥 ELIMINATED: ${data.name} (${data.isSpy ? 'SPY' : 'CIVILIAN'}) received ${data.votes} votes!`);
    });

    this.socket.on('spy_gameOver', (data) => {
      sounds.playVictory();
      alert(data.message);
    });
  }

  destroy() {
    this.socket.off('spy_secretWord');
    this.socket.off('spy_turnPrompt');
    this.socket.off('spy_newDescription');
    this.socket.off('spy_votingStarted');
    this.socket.off('spy_tick');
    this.socket.off('spy_playerEliminated');
    this.socket.off('spy_gameOver');
  }
}
